module.exports = __webpack_public_path__ + "static/media/is-favourite-circle.d61382f5.svg";